import './Tags.scss';
import { prefixClass } from 'lib/utils';
import classNames from 'classnames';
import { Tooltip } from '../Tooltip/Tooltip';

type TagType = 'pill' | 'flag' | 'user-type';
type TagColors =
  | 'purple'
  | 'orange'
  | 'red'
  | 'darkpurple'
  | 'blue'
  | 'teal'
  | 'darkgreen'
  | 'green'
  | 'grey'
  | 'black';

export interface TagProps {
  id?: string;
  tag: string;
  toolTip?: string;
  tagType?: TagType;
  color?: TagColors;
}

interface TagsProps {
  tags: TagProps[];
  onClick?: (tag: string) => void;
}

const Tags = ({ tags, onClick }: TagsProps) => {
  const prefix = prefixClass('q2-tags');
  return (
    <div className={prefix()}>
      {tags.map((tag, index) => {
        const tagElement = (
          <div
            key={index}
            className={classNames(prefix('tag'), [tag.tagType], [tag.color])}
            onClick={() => onClick?.(tag.id || tag.tag)}
          >
            {tag.tag}
          </div>
        );

        // Wrap with Tooltip if toolTip is provided
        return tag.toolTip ? (
          <Tooltip key={index} content={tag.toolTip} position="top">
            {tagElement}
          </Tooltip>
        ) : (
          tagElement
        );
      })}
    </div>
  );
};

export default Tags;
